/* tt-forms-skin.js - the Shopify Forms dropdowns (country, state), in this theme's style.

   The B2B sign-up form (Shopify Forms) draws in a shadow DOM. Its fields take their look from
   custom properties on the host (assets/tt-dealer-application.css), but its dropdown list reuses
   the FIELD colour, so an open list of countries or states sat flush on the fields under it with
   nothing to tell them apart, and the current option wore a white outline box (Josh, 2026-10-16:
   "City and state menus need design help on both sites").

   The shadow root is open, so a stylesheet can be added inside it. Selectors match the class-name
   PREFIX the app uses (_dropdownContainer_, _optionList_, ...), not the hashed suffix, so an app
   update that only rehashes keeps working; one that renames them falls back to the app's own look,
   never to a broken one. Colours are theme tokens: custom properties inherit into a shadow tree. */
(function () {
  'use strict';

  var CSS = [
    /* A FLOATING CARD, NOT A FIELD. Josh, 2026-10-16, second pass: the list was the form's full
       width, so its edges ran into the fields under it and the right edge was clipped. Inset 8px
       each side, a real 1px border (an outer shadow is cut by the form's own clipping), a deeper
       drop shadow, and a fill one step up from the fields. */
    '[class*="_dropdownContainer_"] {',
    '  left: 8px !important;',
    '  right: 8px !important;',
    '  width: auto !important;',
    '  border-radius: 0 !important;',
    '  margin-top: 4px;',
    '  z-index: 20;',
    '  border: 1px solid var(--z-divider-str) !important;',
    '  box-shadow: var(--z-shadow-pop) !important;',
    '}',
    '[class*="_optionList_"] {',
    '  background: var(--z-field-focus) !important;',
    '  color: var(--z-ink) !important;',
    '  padding: 6px 0 !important;',
    '  max-height: 280px !important;',
    '}',
    '[class*="_optionListItem_"] {',
    '  margin: 0 !important;',
    '  border-radius: 0 !important;',
    '  box-shadow: none !important;',
    '  outline: none !important;',
    '  background: transparent !important;',
    '}',
    '[class*="_optionListItem_"] > div {',
    '  padding: 11px 18px !important;',
    '  border-radius: 0 !important;',
    '  outline: none !important;',
    '  font-family: var(--z-font-text) !important;',
    '  font-size: 15px !important;',
    '  font-weight: 500 !important;',
    '  line-height: 1.35 !important;',
    '  color: var(--z-ink) !important;',
    '  background: transparent !important;',
    '}',
    '[class*="_optionListItem_"]:hover > div,',
    '[class*="_optionListItem_"] > div:focus {',
    '  background: var(--z-field) !important;',
    '}',
    '[class*="_optionListItemSelected_"] > div {',
    '  background: var(--z-panel) !important;',
    '  box-shadow: inset 3px 0 0 var(--z-ink) !important;',
    '}',
  ].join('\n');

  function skin(host) {
    if (!host.shadowRoot || host.shadowRoot.querySelector('style[data-tt-skin]')) return !!host.shadowRoot;
    var style = document.createElement('style');
    style.setAttribute('data-tt-skin', '');
    style.textContent = CSS;
    host.shadowRoot.appendChild(style);
    return true;
  }

  function run() {
    var pending = 0;
    document.querySelectorAll('.ap-app shopify-forms-embed').forEach(function (h) { if (!skin(h)) pending++; });
    return pending === 0 && document.querySelector('.ap-app shopify-forms-embed');
  }

  /* The app mounts its element after load; watch until it has, then stop watching. */
  if (run()) return;
  var mo = new MutationObserver(function () { if (run()) mo.disconnect(); });
  mo.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { mo.disconnect(); }, 30000);
})();
